import { YodaColors, YodaFontSize } from 'yoda-ui/yodaTheme';

export const stepperStyle = {
  padding: 0,
  fontSize: YodaFontSize.medium,

  '& span': {
    color: `${YodaColors.textSecondary}`,
    cursor: 'pointer',
    '&.Mui-disabled': {
      cursor: 'not-allowed',
    },
  },
  '& span.MuiStepLabel-completed': {
    color: `${YodaColors.textSecondary}`,
  },
  '& span.Mui-active': {
    color: `${YodaColors.blue7}`,
  },
  '& span.Mui-error': {
    color: `${YodaColors.textSecondary}`,
  },
};
